import { Colors, Services } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, notificationsColors, sizes } from '@/utils'

import button from '@/components/button'
import balanceLimits from '@/components/services/settingsUser/notifications/events/panel/balanceLimits'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderTitle(h) {
  if (this.viewport.size.width > 768) {
    return h(
      textOverflow,
      {
        props: {
          value: this.getTranslate(this.path)
        }
      }
    )
  }

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(this.path),
        color: Colors.grey
      }
    }
  )
}
function renderEditButton(h) {
  if (this.hasSettings) {
    let editIcon
    if (this.permission === 'read') {
      editIcon = icons.remove_red_eye
    } else {
      editIcon = icons.edit
    }

    return h(
      button,
      {
        props: {
          icon: editIcon,
          mode: buttonModes.flat,
          size: sizes.small
        }
      }
    )
  }

  return h('div')
}
function renderChannel(h, channel) {
  const notAvailable = !this.availableChannels.includes(channel)
  const inProxy = this.proxy.channels?.includes(channel)
  const label = this.getTranslate(`${Services.sendings}.types.${channel}`)
  const size = sizes.tiny
  let color
  let mode
  let channelState
  if (inProxy) {
    color = notificationsColors[channel]
    mode = buttonModes.filled
    channelState = 'on'
  } else {
    color = Colors.grey
    mode = buttonModes.flat
    channelState = 'off'
  }
  const key = [ this.path, channel ].join(':')
  let channelOpacity
  if (notAvailable) {
    channelOpacity = 0
  } else {
    channelOpacity = 1
  }
  const style = { opacity: channelOpacity }
  const props = {
    label,
    size,
    color,
    mode
  }

  if (this.permission === 'read') {
    return h(
      tag,
      {
        style,
        props: {
          ...props,
          as: 'button'
        },
        key
      }
    )
  }

  return h(
    button,
    {
      style,
      props: {
        ...props,
        tooltip: this.getTranslate(`${Services.notifications}.tooltips.channel.${channelState}`),
        loading: this.loading,
        disabled: this.loading || notAvailable
      },
      key,
      on: {
        click: event => {
          event.stopPropagation()
          this.update(channel)
          this.$emit('click', channel)
        }
      }
    }
  )
}
function renderChannels(h) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}-panel__channels`
    },
    [
      NOTIFICATIONS_AVAILABLE_TYPES.map(type => {
        return renderChannel.call(this, h, type)
      })
    ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}-panel__header`
    },
    [
      renderTitle.call(this, h),
      renderEditButton.call(this, h),
      renderChannels.call(this, h)
    ]
  )
}

function renderBodyByPath(h) {
  switch (this.path) {
    case 'notifications.events.balance.limit':
    case 'notifications.childrenUsersEvents.balance.limit': {
      return h(
        balanceLimits,
        {
          props: {
            path: this.path,
            value: this.proxy.settings,
            UserId: this.UserId,
            ResellerId: this.ResellerId,
            currency: this.currency,
            permission: this.permission
          },
          on: {
            input: event => {
              this.proxy.settings = event
            }
          }
        }
      )
    }
  }
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}-panel__body`
    },
    [ renderBodyByPath.call(this, h) ]
  )
}

export default function(h) {
  if (this.permission !== false) {
    return h(
      components['expansion-panel'],
      {
        props: { preventClick: !this.hasSettings },
        scopedSlots: {
          header: () => {
            return renderHeader.call(this, h)
          },
          default: () => {
            return renderBody.call(this, h)
          }
        },
        key: this.path
      }
    )
  }
}
